import styled from '@emotion/styled/macro';
import { useEffect, useState } from "react";
import { PageWrapper } from "../../layout/components/Layout.styles";

const ResponseContainer = styled.div`
  padding: 30px;
  max-width: 600px;
  width: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const StatusIcon = styled.div`
  font-size: 60px;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  margin-bottom: 20px;
  color: ${props => props.color || '#333'};
`;

const Message = styled.p`
  font-size: 16px;
  margin-bottom: 20px;
  line-height: 1.5;
`;

// const DetailsList = styled.div`
//   text-align: left;
//   background-color: #f8f8f8;
//   padding: 15px;
//   border-radius: 4px;
//   margin-bottom: 20px;
// `;

// const Detail = styled.div`
//   margin-bottom: 8px;
//   display: flex;
  
//   strong {
//     min-width: 130px;
//   }
// `;

// const Button = styled.button`
//   background-color: #1565c0;
//   color: white;
//   border: none;
//   padding: 10px 20px;
//   border-radius: 4px;
//   font-size: 16px;
//   cursor: pointer;
//   transition: background-color 0.3s;
  
//   &:hover {
//     background-color: #0d47a1;
//   }
// `;

export function DocuSignResponseComponent(props) {
  const [status, setStatus] = useState('loading');
  // const [params, setParams] = useState({});
  const [isSendingRequest, setIsSendingRequest] = useState(true);

  useEffect(() => {
    // Parse the URL search parameters
    const searchParams = new URLSearchParams(window.location.search);
    const paramObj = {};
    
    // Convert parameters to an object
    for (const [key, value] of searchParams.entries()) {
      paramObj[key] = value;
    }
    
    let statusL = 'loading';
    // setParams(paramObj);
    
    // Determine status based on parameters
    if (paramObj.event === 'signing_complete') {
      setStatus('success');
      statusL = 'success';
    } else if (paramObj.event === 'cancel' || paramObj.event === 'decline') {
      setStatus('cancelled');
      statusL = 'cancelled';
    } else if (paramObj.event === 'exception') {
      setStatus('error');
      statusL = 'error'
    } else {
      // If we have an envelope ID but no specific event
      if (paramObj.envelopeId) {
        setStatus('processed');
        statusL = 'processed';
      } else {
        setStatus('unknown');
        statusL = 'unknown';
      }
    }
    
    setIsSendingRequest(false);
    if (window.opener) {
      window.opener.postMessage({ type: 'DOCUSIGN_COMPLETE', status: statusL, params: paramObj }, '*');
    } else if (window.parent !== window) {
      window.parent.postMessage({ type: 'DOCUSIGN_COMPLETE', status: statusL, params: paramObj }, '*');
    }
    // Optional: you might want to notify your backend about the status
    // This could be done here
  }, []);

  // const handleClose = () => {
  //   // If this is opened in a popup or iframe, close it
  //   if (window.opener) {
  //     window.opener.postMessage({ type: 'DOCUSIGN_COMPLETE', status, params }, '*');
  //     window.close();
  //   } else if (window.parent !== window) {
  //     window.parent.postMessage({ type: 'DOCUSIGN_COMPLETE', status, params }, '*');
  //   }
  //   // Otherwise redirect to a relevant page
  //   // else {
  //   //   window.location.href = '/';
  //   // }
  // };

  const renderContent = () => {
    if (isSendingRequest) {
      return (
        <>
          <StatusIcon>⏳</StatusIcon>
          <Title>Processing...</Title>
          <Message>Please wait while we process your document.</Message>
        </>
      );
    }

    switch (status) {
      case 'success':
        return (
          <>
            <StatusIcon>✅</StatusIcon>
            <Title color="#2e7d32">Document Signed Successfully!</Title>
            <Message>
              Thank you for signing the document. Your signature has been recorded.
            </Message>
          </>
        );
      
      case 'cancelled':
        return (
          <>
            <StatusIcon>❌</StatusIcon>
            <Title color="#d32f2f">Signing Cancelled</Title>
            <Message>
              You've cancelled the document signing process. If this was a mistake, 
              you can try again later.
            </Message>
          </>
        );
      
      case 'error':
        return (
          <>
            <StatusIcon>⚠️</StatusIcon>
            <Title color="#ed6c02">Error Processing Document</Title>
            <Message>
              We encountered an error while processing your document. 
              Please try again or contact support if the issue persists.
            </Message>
          </>
        );
      
      case 'processed':
        return (
          <>
            <StatusIcon>📄</StatusIcon>
            <Title color="#1976d2">Document Processed</Title>
            <Message>
              Your document has been processed. Thank you for completing this step.
            </Message>
          </>
        );
      
      default:
        return (
          <>
            <StatusIcon>❓</StatusIcon>
            <Title color="#9e9e9e">Unknown Status</Title>
            <Message>
              We received a response, but couldn't determine the status.
              Please contact support for assistance.
            </Message>
          </>
        );
    }
  };

  return (
    <PageWrapper style={{ alignItems: 'center', justifyContent: 'center' }}>
      <ResponseContainer>
        {renderContent()}
        
        {/* {!isSendingRequest && (
          <>
            <DetailsList>
              <Detail><strong>Status:</strong> {status}</Detail>
              {params.envelopeId && <Detail><strong>Envelope ID:</strong> {params.envelopeId}</Detail>}
              {params.event && <Detail><strong>Event:</strong> {params.event}</Detail>}
              {Object.entries(params)
                .filter(([key]) => !['envelopeId', 'event'].includes(key))
                .map(([key, value]) => (
                  <Detail key={key}><strong>{key}:</strong> {value}</Detail>
                ))
              }
            </DetailsList>
            
            <Button onClick={handleClose}>
              {window.opener || window.parent !== window ? 'Close Window' : 'Return to Home'}
            </Button>
          </>
        )} */}
      </ResponseContainer>
    </PageWrapper>
  );
}